'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDownloadOutline = function TiDownloadOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 28.3c0-0.1 0-0.3-0.1-0.5l-3.3-10c-0.2-0.7-0.9-1.1-1.6-1.1h-0.9l1.1-1.2c2-1.9 2-5.1 0-7-1.3-1.4-3.4-1.8-5.2-1.2v-2.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v2.3c-1.8-0.6-3.8-0.2-5.2 1.2-1.9 1.9-1.9 5.1 0 7l1.1 1.2h-0.9c-0.7 0-1.4 0.4-1.6 1.1l-3.3 10c-0.1 0.2-0.1 0.4-0.1 0.5 0 0 0 8.4 0 8.4 0 0.9 0.7 1.6 1.7 1.6h26.6c1 0 1.7-0.7 1.7-1.6 0 0 0-8.4 0-8.4z m-22.8-17.5c0.3-0.3 0.7-0.5 1.1-0.5s0.9 0.2 1.2 0.5l3.8 3.8v-9.6c0-0.9 0.8-1.7 1.7-1.7s1.7 0.8 1.7 1.7v9.6l3.8-3.8c0.6-0.6 1.7-0.6 2.3 0 0.7 0.7 0.7 1.7 0 2.4l-7.8 7.8-7.8-7.8c-0.7-0.7-0.7-1.7 0-2.4z m-1 9.2h3.1l5.7 5.7 5.7-5.7h3.1l2.8 8.3h-23.2l2.8-8.3z m20.5 15h-23.4v-5h23.4v5z' })
        )
    );
};

exports.default = TiDownloadOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/download-outline.js
// module id = 1872
// module chunks = 0